import {JsonObject, JsonProperty} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';

@JsonObject('Message')
export class Message {

    @JsonProperty('texts',TSStringToStringMapConverter)
    texts:TSMap<string,string> = new TSMap();// { [key: string]: string; } = {};

    @JsonProperty('clearText')
    clearText =  false;

    @JsonProperty('uid',String,true)
    uid = '';

    @JsonProperty('fontSize',Number,true)
    fontSize = 0;

    @JsonProperty('fontFamily',String,true)
    fontFamily = '';

    @JsonProperty('fontColor',String,true)
    fontColor = '#000000';

    @JsonProperty('fontWeight',String,true)
    fontWeight = '';

    constructor() {

    }
}
